import script from "./DetailSearchInvoiceNonProxySP1.vue?vue&type=script&setup=true&lang=js"
export * from "./DetailSearchInvoiceNonProxySP1.vue?vue&type=script&setup=true&lang=js"

import "./DetailSearchInvoiceNonProxySP1.vue?vue&type=style&index=0&id=b22cb072&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b22cb072"]])

export default __exports__